<div class="app-page flex-column flex-column-fluid" id="kt_app_page">

  <div class="maintenance_mode w-100">
    
    <ng-template #maintenance1>
      <div class="bg-dark text-white p-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between w-100" style="position: relative;" id="maintenance_1">
        <div class="d-flex align-items-start">
            <i class="bi bi-exclamation-circle text-white m-4" style="font-size: 2rem;"></i>
            <div>
              <div class="fw-bold fs-5">
                Application Planned Maintenance
              </div>
              <div class="fs-6">
                {{maintenanceMessage1}} {{CurrentTimeforMaintennace}}
              </div>
            </div>
          <button type="button" class="btn-close btn-close-white p-5 px-15" style="position: absolute; top: 2px; right:2px;
          display: flex; align-items: center;" aria-label="Close" (click)="Maintenance1Dismisal()">
            <span class="fs-7 d-lg-inline p-4">Close</span>
          </button>
        
        </div>
      </div>
    </ng-template>

    <ng-template #maintenance2 >
      <div class="bg-dark text-white p-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between w-100" style="z-index: 9999; position: relative;" id="maintenance_2">
        <div class="d-flex align-items-start">
          <i class="bi bi-exclamation-circle text-white m-4" style="font-size: 2rem;"></i>
          <div>
            <div class="fw-bold fs-5">
            Application Planned Maintenance today!
            </div>
            <div class="fs-6">
            {{maintenanceMessage2}} {{CurrentTimeforMaintennace}}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #maintenance3 >
      <div class="bg-dark text-danger p-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between w-100" style="z-index: 9999; position: relative;" id="maintenance_3">
        <div class="d-flex align-items-start">
          <i class="bi bi-exclamation-circle text-danger m-4" style="font-size: 2rem;"></i>
          <div>
            <div class="fw-bold fs-5">
            Application Planned Maintenance today!
            </div>
            <div class="fs-6">
            {{maintenanceMessage3}} {{CurrentTimeforMaintennace}}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-container *ngIf="isMaintenanceMode && !isMaintenancMessage1Dismissed && maintenancePrior" 
      [ngTemplateOutlet]="maintenance1"> 
    </ng-container>
    <ng-container *ngIf="isMaintenanceMode && maintenanceToday" 
      [ngTemplateOutlet]="maintenance2"> 
    </ng-container>
    <ng-container *ngIf="isMaintenanceMode && maintenanceTodayIT" 
      [ngTemplateOutlet]="maintenance3"> 
    </ng-container>
  </div>


  <div *ngIf="readyToRender">
    <!--begin::Header-->
    <app-header *ngIf="!maintenanceTodayNonIT"></app-header>

    <!--end::Header-->
    <!--begin::Wrapper-->
    <div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
      <!--begin::Main-->
      <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <!--begin::Content wrapper-->
        <router-outlet></router-outlet>
        <!--end::Content wrapper-->
        <!--begin::Footer-->
        <app-footer></app-footer>
        <!--end::Footer-->
      </div>
      <!--end:::Main-->
    </div>
    <!--end::Wrapper-->
  </div>
</div>
